import React from "react";
import { boardMembers, denetlemeKurulu } from "../data/content";

const initials = (name: string) =>
  name.split(" ").map((w) => w.charAt(0).toUpperCase()).join("");

const BoardPage: React.FC = () => (
  <div className="min-h-screen bg-bg-page pt-24">
    {/* Hero */}
    <div className="bg-gradient-to-br from-[#0F172A] to-[#1A2540] py-16 text-white">
      <div className="w-full px-6 xl:px-16 text-center">
        <div className="text-brand-gold text-sm font-semibold uppercase tracking-wider mb-2">
          Kurumsal
        </div>
        <h1 className="text-3xl md:text-4xl font-bold mb-3">Yönetim Kurulu</h1>
        <p className="text-white/70 max-w-2xl mx-auto leading-relaxed">
          Derneğimizi gönüllülük ve sorumluluk bilinciyle yöneten, Trabzon sevdalısı ekibimizle tanışın.
        </p>
      </div>
    </div>

    <div className="w-full px-6 xl:px-16 py-16">
      {/* Başkan — öne çıkan kart */}
      {boardMembers.slice(0, 1).map((member) => (
        <div key={member.id} className="max-w-2xl mx-auto mb-12">
          <div className="card border-t-4 border-brand-bordo flex flex-col md:flex-row items-center gap-8">
            {member.image ? (
              <img
                src={member.image}
                alt={member.name}
                className="w-28 h-28 rounded-full object-cover flex-shrink-0 shadow-lg border-4 border-brand-bordo"
              />
            ) : (
              <div className="w-28 h-28 rounded-full bg-gradient-to-br from-brand-bordo to-brand-bordo-dark flex items-center justify-center text-white font-extrabold text-4xl flex-shrink-0 shadow-lg">
                {initials(member.name)}
              </div>
            )}
            <div className="text-center md:text-left">
              <div className="text-brand-gold text-xs font-semibold uppercase tracking-widest mb-1">Dernek Başkanı</div>
              <h2 className="text-2xl font-bold text-text-primary mb-2">{member.name}</h2>
              {member.message && (
                <blockquote className="text-text-muted text-sm italic leading-relaxed border-l-4 border-brand-bordo pl-4">
                  "{member.message}"
                </blockquote>
              )}
            </div>
          </div>
        </div>
      ))}

      {/* Yönetim Kurulu Üyeleri */}
      <div className="mb-16">
        <h3 className="text-center text-lg font-bold text-text-primary mb-8 flex items-center justify-center gap-3">
          <span className="h-px w-16 bg-border-light inline-block" />
          Yönetim Kurulu Üyeleri
          <span className="h-px w-16 bg-border-light inline-block" />
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 max-w-3xl mx-auto">
          {boardMembers.slice(1, 5).map((member) => (
            <div
              key={member.id}
              className="card text-center group hover:-translate-y-1 transition-transform"
            >
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-16 h-16 rounded-full object-cover mx-auto mb-3 border-2 border-brand-bordo"
                />
              ) : (
                <div
                  className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3 text-white font-bold text-xl shadow-md"
                  style={{ background: "linear-gradient(135deg, #8B1428 0%, #0F4C81 100%)" }}
                >
                  {initials(member.name)}
                </div>
              )}
              <div className="font-bold text-text-primary text-sm">{member.name}</div>
              <div className="text-text-muted text-xs mt-1">{member.role}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Başkan Yardımcıları */}
      <div className="mb-16">
        <h3 className="text-center text-lg font-bold text-text-primary mb-8 flex items-center justify-center gap-3">
          <span className="h-px w-16 bg-border-light inline-block" />
          Başkan Yardımcılarımız
          <span className="h-px w-16 bg-border-light inline-block" />
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {boardMembers.slice(5).map((member) => (
            <div
              key={member.id}
              className="card text-center group hover:-translate-y-1 transition-transform"
            >
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3 text-white font-bold text-xl shadow-md"
                style={{ background: "linear-gradient(135deg, #8B1428 0%, #0F4C81 100%)" }}
              >
                {initials(member.name)}
              </div>
              <div className="font-bold text-text-primary text-sm">{member.name}</div>
              <div className="text-text-muted text-xs mt-1">{member.role}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Denetleme Kurulu */}
      <div>
        <h3 className="text-center text-lg font-bold text-text-primary mb-8 flex items-center justify-center gap-3">
          <span className="h-px w-16 bg-border-light inline-block" />
          Denetleme Kurulu
          <span className="h-px w-16 bg-border-light inline-block" />
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 max-w-2xl mx-auto">
          {denetlemeKurulu.map((member) => (
            <div key={member.id} className="card text-center group hover:-translate-y-1 transition-transform border-t-4 border-brand-blue">
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-3 text-white font-bold text-xl shadow-md"
                style={{ background: "linear-gradient(135deg, #8B1428 0%, #0F4C81 100%)" }}
              >
                {initials(member.name)}
              </div>
              <div className="font-bold text-text-primary text-sm">{member.name}</div>
              <div className="text-text-muted text-xs mt-1">{member.role}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default BoardPage;